<template>
    <div class="current-location" :style="styles">
        <button @click="getCurrentPosition" class="__kfc_button location">
            <div class="image">
                <img src="@/assets/icons/location.svg" alt="">
                <img class="__kfc_image_hover" src="@/assets/icons/hovered_location.svg" alt="">
            </div>
            <span v-if="label" class="__kfc_r_5">{{ label }}</span>
        </button>
    </div>
</template>

<script>
import Req from '@/utils/Request';
import { useGeolocation } from '@/utils/useGeolocation';
import { computed, inject } from 'vue';
import { useStore } from 'vuex';

export default {
    props: ['classes', 'styles', 'label'],
    setup (props, { emit }) {
        const notify = inject('notify');
        const store = useStore();
        const locale = computed(() => store.getters.locale)
        const orderType = computed(() => store.getters['address/getOrderType'])

        const { coords } = useGeolocation();
        const currPos = computed(() => ({
            lat: coords.value.latitude,
            lng: coords.value.longitude,
            error: coords.value.error,
        }));
        const getCurrentPosition = async () => {

            if (currPos.value.error) {
                notify.warning({
                    message: locale.value == 'mn' ? 'Location асаана уу !' : 'Product added to Your Cart',
                    position: 'top-left'
                });
                return;
            }
            if (currPos.value.lat === '' ||
                currPos.value.lng === '' ||
                currPos.value.lat === 0 ||
                currPos.value.lng === 0
            ) {
                notify.warning({
                    message: locale.value == 'mn' ? 'Таны байршлыг татаж байна' : 'Таны байршлыг татаж байна',
                    position: 'top-left'
                });
                return
            }

            const { data: result } = await Req({
                url: '/searchByLocation?lat=' + currPos.value.lat + '&lon=' + currPos.value.lng,
                type: 3,
                method: 'get',
                hideSuccess: true
            });

            if (result.data.length > 0) {
                const newOutletName = await getOutletNameByPodKfc(result.data[0]?.podkfc);
                if (orderType.value === 1) {
                    await store.dispatch('address/updateDeliveryOutletName', newOutletName);
                    await store.dispatch('address/updateDeliveryAddress', result.data[0]);
                } else {
                    await store.dispatch('address/updatePickupAddress', newOutletName);
                }
                emit('getAddress', {
                    address: result.data[0],
                    location: currPos.value
                });
            }
        }
        const getOutletNameByPodKfc = async (podkfc) => {
            const { data: result } = await Req({ url: '/manager/getOutletNameByPodKfc', body: { podcode: podkfc }, hideSuccess: true })
            if (result.success) {
                return result.result
            }
        }
        return {
            getCurrentPosition
        }
    }
}
</script>

<style lang="scss" scoped>
.current-location {
    border-radius: 4px;
    background: $whiteMain;

    .location {
        display: flex;
        gap: 16px;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 0 16px;

        .image {
            position: relative;
        }

        span {
            width: max-content
        }

        &:hover {
            .__kfc_image_hover {
                opacity: 1;
            }

            @media (max-width: 768px) {
                .__kfc_image_hover {
                    opacity: 0;
                }
            }
        }

        img {
            width: 24px;
            height: 24px;
        }
    }
}

.current-location.white_back {
    background: $whiteMain;
}

.current-location.dark_back {
    background: $whiteMain;
}
</style>